import { debounce } from 'es-toolkit';
import { useEffect, useState } from 'react';

export const useDebouncedValue = <T = unknown>(value: T, wait: number) => {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(() => {
		const handler = debounce(() => {
			setDebouncedValue(value);
		}, wait);

		handler();

		return () => {
			handler.cancel();
		};
	}, [value, wait]);

	return debouncedValue;
};
